import { createContext, useContext } from 'react';

export const SidebarContext = createContext<{ isInSidebar: boolean } | null>(null);

export const useSidebarContext = () => useContext(SidebarContext);
